import React from 'react';
import styles from "./popularCorals.module.css"
import ProductCard from "../../product/v2/productCard/productCard";
import {IProduct} from "../../../services/model/Product";

interface Props {
    products: IProduct[];
    header: string;
    productGroup?: string;
}

const PopularCorals: React.FC<Props> = (props) => {

    return (
        <div className={styles.sectionWrapper}>

            {props.products.length !== 0 && (
                <h2 className={styles.product_content_header}>{props.header}</h2>
            )}

            <section className={styles.articles}>
                {props.products.length === 0 ? (
                    <h4>No products found</h4>
                ) : (
                    <>
                        {props.products.map((product, index) => {
                            // Define which products are on sale
                            // const isOnSale = index === 0 || index === 2;
                            // const discountedPrice = (product.price * 0.8).toFixed(2); // 20% off

                            return (
                                <>
                                    {/*<ProductCard*/}
                                    {/*    product={product}*/}
                                    {/*    isOnSale={isOnSale}*/}
                                    {/*    discountedPrice={discountedPrice}*/}
                                    {/*/>*/}
                                    <ProductCard
                                        product={product}
                                    />
                                </>
                            );
                        })}
                    </>
                )}
            </section>
            <div className={styles.cardOverlay}>
                <a className={`${styles.viewBtn} nav-link px-3`}  href={`/${props.productGroup}`}>
                    View All Products
                </a>
            </div>
        </div>
    );
};

export default PopularCorals;
